import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import Loader from '../loader/Loader';
import DropdownItem from '../../dropdown-item/DropdownItem';
import { KeywordResponse } from '../../../models/monitor/KeywordResponse';
import { TagsResponse } from '../../../models/tags/TagsResponse';
import { getTagLabel } from '../../../helpers/tags/TagsHelper';
import { useGetProjectOptionsKeywords } from '../../../api/hooks/project/options/useGetProjectOptionsKeywords';

interface ChangeProjectProps {
  projectId: number;
  projectName: string;
  keywords: KeywordResponse[];
  tags: TagsResponse[];
  onChangeProject: (selectedKeywords: string[]) => void;
}

const ChooseKeywords: React.FC<ChangeProjectProps> = ({
  projectId,
  projectName,
  keywords,
  tags,
  onChangeProject,
}) => {
  const { t } = useTranslation();
  const [selectedItems, setSelectedItems] = useState<{ name: string; type: string }[] | null>(null);
  const { fetchProjectOptionsKeywords } = useGetProjectOptionsKeywords();

  useEffect(() => {
    void prepareCurrentData();
  }, []);

  const prepareOptions = () => {
    return keywords
      .filter((keyword) => keyword.normalizedKeyword !== projectName)
      .map((keyword) => ({
        name: keyword.tagId
          ? getTagLabel(tags, keyword.tagId, keyword.normalizedKeyword)
          : keyword.keyword,
        type: keyword.normalizedKeyword,
      }));
  };

  const prepareCurrentData = async () => {
    const projectOptionsKeywords = await fetchProjectOptionsKeywords({ projectId });
    const allOptions = prepareOptions();
    const selected = allOptions.filter(
      (item) => projectOptionsKeywords.includes(item.type) && item.name !== projectName
    );

    setSelectedItems(selected);
  };

  const handleChange = (e: any) => {
    const updated = e.value || [];
    const withoutProjectName = updated.filter((item: any) => item.normalizedKeyword !== projectName);
    const finalSelection = [...withoutProjectName];
    setSelectedItems(withoutProjectName);
    onChangeProject(finalSelection.map((item) => item.type));
  };

  const isOptionDisabled = (option: { type: string }) => option.type === projectName;

  if (!selectedItems) {
    return <Loader />;
  }

  return (
    <div>
      <MultiSelect
        value={selectedItems}
        onChange={handleChange}
        options={prepareOptions()}
        className="dropdown dropdown--multi-select"
        optionLabel="name"
        optionDisabled={isOptionDisabled}
        itemTemplate={(option) => <DropdownItem name={option.name} />}
        maxSelectedLabels={1}
        selectionLimit={13}
        showSelectAll={false}
        placeholder={t('selectBrands')}
        filter
      />
    </div>
  );
};

export default ChooseKeywords;